import { useEffect, useState } from "react"
import Event from "../components/Event";
import { useParams } from "react-router";
import Loader from "../components/Loader";
import Header from "../components/Header";

function getCurrentUTCDateTime12HourFormat() {
    const now = new Date();
    const year = now.getUTCFullYear();
    const month = padNumber(now.getUTCMonth() + 1);
    const day = padNumber(now.getUTCDate());
    const hours = now.getUTCHours();
    // const meridian = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = (hours % 12) || 12;
    const minutes = padNumber(now.getUTCMinutes());
    const seconds = padNumber(now.getUTCSeconds());

    return `${year}-${month}-${day} ${padNumber(formattedHours)}:${minutes}:${seconds}`;
}

function padNumber(number) {
    return String(number).padStart(2, '0');
}

export default function EventsList() {
    const [isLoading, setIsLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const competitionName = useParams();

    const apiBase = process.env.NODE_ENV === 'development' ? '/' : process.env.REACT_APP_API_URL_Prod;
    const apiEndPoint = apiBase + 'api/ScoreCounter/GetRoundMatchesByCompetitionNameAndDate?CompetitionName='
        + competitionName?.compId?.trim()?.toUpperCase() + '&InstanceDate=' + getCurrentUTCDateTime12HourFormat();
    useEffect(() => {
        (async () => {
           try {
               if (competitionName.compId) {
                   setIsLoading(true);
                   let res = await fetch(apiEndPoint);
                   if (res.ok) {
                       let data = await res.json();
                       if (data.listOfGameMatchDataGroupedByDate && data.listOfGameMatchDataGroupedByDate.length > 0) {
                           let events = [];
                           data.listOfGameMatchDataGroupedByDate.forEach(group => {
                               let { ListOfMatches } = group;
                               if (ListOfMatches.length > 0) {
                                   ListOfMatches.forEach(match => {
                                       if (match.eventStatus && match.eventStatus === 'Future' || match.eventStatus === 'Completed') {
                                           events.push(match);
                                       }
                                   });
                               }
                           });
                           setEvents(events);
                       }
                   }
               }else {
                throw new Error("Competition Id not found");
               }
           } catch (error) {
            console.log(error);
           }
           finally {
               setIsLoading(false);
           }
        })();
    }, [competitionName.compId]);

    return (
        <>
            <header>
                <Header />
            </header>
            <main style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }}>
                {isLoading ? <Loader /> : (
                    events.map(event => (
                        <Event key={event.eventId} data={event} />
                    ))
                )}
            </main>
        </>
    )
}
